export default "__VITE_ASSET__BJZ4YJRt__"